module.exports = __webpack_public_path__ + "912ce9eff6454a827145f1c0909b9559.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/virtual-sports/assets/vfac.png
// module id = 1779
// module chunks = 2